import React from "react";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";

const MusicLinkBarChart = ({ topOsData }) => {
  const { t } = useTranslation();

  const barData = {
    labels: topOsData.labels,
    datasets: [
      {
        label: t('musicLinks.viewStats.topOperatingSystems.chart.label.operatingSystems'),
        data: topOsData.data,
        backgroundColor: '#000a60',
        hoverBackgroundColor: '#000a60',
      }
    ]
  };

  const options = {
      indexAxis: 'y',
      // Elements options apply to all of the options unless overridden in a dataset
      // In this case, we are setting the border of each horizontal bar to be 2px wide
      elements: {
        bar: {
          borderWidth: 2,
        }
      },
      maintainAspectRatio: false,
      responsive: true,
      plugins: {
        legend: {
          position: 'right',
          display: false
        },
        tooltip: {
          callbacks: {
              label: function(context) {
                  var usage = context.raw || '';
                  return t('musicLinks.viewStats.topOperatingSystems.chart.label.noOfViews') + ' : ' + usage + '%';
              }
          }
      }
      },
      scales: {
        x: {
          grid: {
            display: false,
          }
        },
        y: {
          grid: {
            display: false,
          }
        }
      }
    };

  return (
    <>
      <div className="chart-wrapper" style={{ width: '100%', margin: '0 auto', height: 300 }}>
          <Bar data={barData} options={options} />
      </div>
    </>
  );
};

export default MusicLinkBarChart;
